import React from 'react'
// import crossSrc from '../../assets/images/Icons/cross.svg'
import ZeroquizOops from '../../assets/images/ZeroquizOops.svg'
import ButtonPrimaryLg from '../../_atomic-design/atoms/Button/ButtonPrimaryLg'
import GeneralButton from '../../_atomic-design/atoms/Button/GeneralButton'
import ImageTag from '../../_atomic-design/atoms/ImageTag'
import GeneralText from '../../_atomic-design/atoms/Text/GeneralText'
// import HeadingLg from '../../_atomic-design/atoms/Text/HeadingLg'
import { useNavigate } from 'react-router-dom'
import { NavHashLink } from 'react-router-hash-link'

export default function ZeroQuizModal ({ className, active, setActive }) {
  const navigate = useNavigate()
  const goToDashBoard = () => {
    navigate('/Dashboard')
  }

  if (!active) return null
  return (
    <div className='fixed top-10 left-0 w-screen h-screen bg-white/20 backdrop-blur-[20px] z-50 flex justify-center items-center py-[5%]' >
        <div className="w-fit md:w-1/2 mx-4 bg-white rounded-[20px] max-h-screen max-w-xl flex flex-col justify-center items-center m-8 p-8 pt-2" style={{ boxShadow: '0 0 27px rgb(60, 56, 205, 0.15)' }}>
        {/* {
          active && <ImageTag src={crossSrc} onClick={setActive} className='h-5 mb-4 ml-auto cursor-pointer ' />
        } */}
        <h1 className="font-bold text-[32px] md:text-3xl text-[#6042D1] md:mb-5 mt-4">Oops!.</h1>
        <ImageTag src={ZeroquizOops} className='w-1/3 h-1/3 max-w-xs ' />
        <div className='justify-left mt-2'>
        <GeneralText
                      text={'We are unable to generate questions because the uploaded content is not in readable format. Try and upload a text file to generate your questions'}
                      className=" text-[15px] md:text-base font-medium"
                  />
        </div>
        <br/>
        <ButtonPrimaryLg className='' text='Go back to Dashboard' onClick={goToDashBoard}/>
        <NavHashLink className='cursor-pointer py-3  font-bold' to='/#faq' smooth >
        <GeneralButton className='bg-white-100 w-[220px] sm:w-[392px] h-7 sm:h-11 text-xs sm:text-xl block rounded-md text-app-primary border-2 border-app-primary' content='Go to FAQ'/>
        </NavHashLink>
        </div>
    </div>
  )
}
